import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import {
  FORMAT_AUTO,
  NUMBER_FORMAT_ITEMS,
} from "%/dynamic-components/render-engine/helpers/number-format";

export default class NumberFormat extends BaseOption {
  static userInterfaceComponent = {
    label: "Number Format",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: NUMBER_FORMAT_ITEMS,
    },
  };

  // "As entered" keeps every already-authored element rendering exactly what it
  // rendered before this option existed.
  static defaultValue = FORMAT_AUTO;

  static convertConfigValueToCompiledValue(configValue) {
    return configValue;
  }
}
